<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h2 class="fm-title1">L<span class="smallcaps">IST OF</span> M<span class="smallcaps">APS</span></h2>
<p class="centerm"><em class="italic">Maps by Edward Alexander</em></p>
<h2 class="toct"><a href="#/xhtml/09_Introduction#page_xiv">Vicksburg Campaign, March 29–JuIy 4, 1863</a></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter4#page_30" title="Link target outside of Sample">Jackson, MS 1863</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter6#page_54" title="Link target outside of Sample">Johnston’s Plan for Pemberton, May 13–14, 1863</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter7#page_61" title="Link target outside of Sample">Battle of Jackson, May 14, 1863</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter11#page_134" title="Link target outside of Sample">Battle of Jackson, May 14, 1863 (Modern Background)</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Chapter12#page_136" title="Link target outside of Sample">Points of Interest, Jackson, MS</span></h2>
<div class="image_container">
<img alt="images" src="images/f0vii-01.jpg"/>
<p class="caption">JACKSON BATTLEFIELD, MS</p>
<p class="caption">The National Park Service assessment of Jackson’s core battlefield areas overlays atop a busy state capital, with virtually no preserved space. The battlefield study area includes the approach routes of the Federal army as well as part of the evacuation route of the Confederates.</p>
<p class="captionk"><em class="italic">National Park Service</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Maps.vue?4ae5e635